import { gql } from 'graphql-request';

export const productSpecialistQuery = gql`
  {
    specialists: item(path: "{69220EC7-BCCC-41BB-B1FA-9415ACEA8204}", language: "nl-NL") {
      children {
        results {
          ... on ProductSpecialistPerson {
            fullName {
              value
            }
            photo {
              src(maxWidth: 155, maxHeight: 155)
            }
            sector {
              targetItems {
                name
                ... on SectorRoot {
                  sectorPhone {
                    value
                  }
                  sectorEmail {
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
    text: item(path: "{6E0FF22B-A815-4948-8574-F90E95500F00}", language: "nl-NL") {
      ... on ProductSpecialText {
        title {
          value
        }
        subText {
          value
        }
        emailText {
          value
        }
      }
    }
  }
`;
